import http from '@/lib/http';

export default {
    getDict(types) {
        return http({
            url: `/baseService/getDict/${types}`
        });
    }
}